/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Input_Position_Y_TopInputs */

const en_input_position_y_top = /** @type {(inputs: Input_Position_Y_TopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Top`)
};

const fr_input_position_y_top = /** @type {(inputs: Input_Position_Y_TopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haut`)
};

const de_input_position_y_top = /** @type {(inputs: Input_Position_Y_TopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spitze`)
};

const it_input_position_y_top = /** @type {(inputs: Input_Position_Y_TopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Superiore`)
};

const ru_input_position_y_top = /** @type {(inputs: Input_Position_Y_TopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вершина`)
};

const es_input_position_y_top = /** @type {(inputs: Input_Position_Y_TopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arriba`)
};

const zh_cn2_input_position_y_top = /** @type {(inputs: Input_Position_Y_TopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`顶部`)
};

const ja_input_position_y_top = /** @type {(inputs: Input_Position_Y_TopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`トップ`)
};

const hi_input_position_y_top = /** @type {(inputs: Input_Position_Y_TopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`शीर्ष`)
};

const pt_pt2_input_position_y_top = /** @type {(inputs: Input_Position_Y_TopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Principal`)
};

/**
* | output |
* | --- |
* | "Top" |
*
* @param {Input_Position_Y_TopInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const input_position_y_top = /** @type {((inputs?: Input_Position_Y_TopInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Input_Position_Y_TopInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_input_position_y_top(inputs)
	if (locale === "de") return de_input_position_y_top(inputs)
	if (locale === "it") return it_input_position_y_top(inputs)
	if (locale === "ru") return ru_input_position_y_top(inputs)
	if (locale === "es") return es_input_position_y_top(inputs)
	if (locale === "zh-CN") return zh_cn2_input_position_y_top(inputs)
	if (locale === "ja") return ja_input_position_y_top(inputs)
	if (locale === "hi") return hi_input_position_y_top(inputs)
	if (locale === "pt-PT") return pt_pt2_input_position_y_top(inputs)
	return en_input_position_y_top(inputs)
});